/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import {
  Column,
} from 'hedron';
import { Calculator as CalculatorModel } from 'models';
import {
  ButtonTextWhite,
  PaddedTopRow,
  PaddedBottomRow,
  CalculatorContainer,
  WhiteArrow,
  WhiteHorizontalLine,
} from 'kentico-blocks/Calculator/styled';
import TotalOptimisationGrid
  from 'kentico-blocks/Calculator/CalculatorDetailsView/TotalOptimisationGrid';
import CostOfZoniferoGrid from 'kentico-blocks/Calculator/CalculatorDetailsView/CostOfZoniferoGrid';
import ds from 'designsystem';
import styled from 'styled-components';

const BlueBackground = styled.div`
  position: absolute;
  background-color: ${ds.brand('product')};
  top: 0;
  left: 0;
  width: 100vw;
  height: 130%;
`;

const FlexRightColumn = styled(Column)`
  display: flex;
  justify-content: flex-end;
  padding-top: ${ds.get('metrics.xs')};
`;

const WhiteLeftArrow = styled(WhiteArrow)`
  transform: translate(3px, -3px) rotate(135deg);
  margin-left: 0;
`;

@inject('calculatorStore')
@observer
export default class CalculatorDetailsView extends Component {
  static propTypes = {
    data: PropTypes.instanceOf(CalculatorModel).isRequired,
    innerRef: PropTypes.func,
  };

  static defaultProps = {
    innerRef: () => {},
  };

  constructor(props) {
    super(props);
    this.elementRef = React.createRef();
  }

  render() {
    const {
      onClickPrev,
      innerRef,
      data,
    } = this.props;
    return (
      <CalculatorContainer>
        <BlueBackground innerRef={ref => innerRef(ref)} />
        <PaddedTopRow>
          <Column>
            <ButtonTextWhite
              big
              onClick={onClickPrev}
            >
              <WhiteLeftArrow />
              {data.returnToMainViewLinkText}
            </ButtonTextWhite>
            <WhiteHorizontalLine
              noMarginBottom
            />
          </Column>
        </PaddedTopRow>
        <TotalOptimisationGrid data={data} />
        <CostOfZoniferoGrid data={data} />
        <PaddedBottomRow>
          <FlexRightColumn>
            <ButtonTextWhite
              big
              onClick={onClickPrev}
            >
              <WhiteLeftArrow />
              {data.returnToMainViewLinkText}
            </ButtonTextWhite>
          </FlexRightColumn>
        </PaddedBottomRow>
      </CalculatorContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/kentico-blocks/Calculator/CalculatorDetailsView/index.jsx